exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#headImage {\n  width: calc(100% + 80px);\n  background-color: #ad0e68;\n  position: relative;\n  padding-top: 28.5%; }\n  #headImage .image {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    overflow: hidden;\n    margin: 1em auto;\n    margin-top: 0;\n    max-width: 720px;\n    border-radius: 0 100px; }\n  #headImage .image img {\n      min-width: 100%;\n      min-height: 100%;\n      position: relative;\n      top: 50%;\n      -webkit-transform: translateX(-50%) translateY(-50%);\n              transform: translateX(-50%) translateY(-50%);\n      left: 50%; }\n  h1 {\n  margin-bottom: 0; }\n  h2 {\n  font-size: 1.2em;\n  font-family: 'Roboto';\n  margin-bottom: 0px; }\n  div {\n  margin-bottom: 1rem; }\n  .dates table {\n  margin-left: 1em;\n  width: 50%;\n  min-width: 368px; }\n  .dates table tr:nth-child(2n) {\n    background-color: #e6e5e5; }\n  .dates table tr .middle {\n    margin: 0 auto;\n    text-align: center; }\n  .dates table tr td:last-child {\n    text-align: right; }\n  .lecturer img {\n  height: 1.5em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/leonhard/Projekte/braungardt/angular/src/app/kurs/kurs.component.scss
// module id = ../../../../../src/app/kurs/kurs.component.scss
// module chunks = main